import { render } from "./WnUpload.vue?vue&type=template&id=3a89914a&scoped=true"
import script from "./WnUpload.vue?vue&type=script&lang=js"
export * from "./WnUpload.vue?vue&type=script&lang=js"

import "./WnUpload.vue?vue&type=style&index=0&id=3a89914a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a89914a"]])

export default __exports__